import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    computed: {
        content: {
            get() {
                return this.$props.value;
            },
            set(value) {
                this.$emit('input', value);
                this.$emit('change');
            }
        }
    }
})
export default class Toggle extends Vue {
    @Prop() value!: boolean;
    @Prop() disabled?: boolean;
}
